import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { AppConfigService } from '../services/app-config.service';

/**
 * Keeps the second-factor screens off a deployment that has the feature
 * switched off.
 *
 * Hiding the entry points is not enough on its own — the routes stay
 * addressable, and someone arriving on one by typed URL, bookmark or stale
 * link would otherwise get a rendered screen whose every request 404s. This
 * turns that into an ordinary redirect.
 *
 * The two routes send the visitor somewhere different because they sit at
 * different points in the sign-in: the challenge screen belongs to a login
 * in progress, so an unusable one goes back to the start; the setup screen
 * belongs to a signed-in user, so it returns to where they came from.
 */
function guardFor(fallback: string): CanActivateFn {
  return (): boolean | UrlTree => {
    const config = inject(AppConfigService);
    const router = inject(Router);
    return config.mfaEnabled ? true : router.parseUrl(fallback);
  };
}

/** Guards `/mfa` — the challenge step of a sign-in. */
export const mfaChallengeEnabledGuard = guardFor('/login');

/** Guards `/security/mfa` — self-service enrolment. */
export const mfaSetupEnabledGuard = guardFor('/labs');
